var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShuffle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.889,
    height: 15.66,
    viewBox: "0 0 20.889 15.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4360",
    "data-name": "Group 4360",
    transform: "translate(-1864.427 -1172.17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1719",
    "data-name": "Group 1719",
    transform: "translate(-9047.944 11388.542)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4361",
    "data-name": "Group 4361"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-round-back",
    "data-name": "Icon ionic-ios-arrow-round-back",
    d: "M5.673.2a.711.711,0,0,1,.005,1l-3.3,3.313H14.958a.707.707,0,0,1,0,1.414H2.377L5.684,9.24a.716.716,0,0,1-.005,1,.7.7,0,0,1-1-.005L.2,5.721h0A.794.794,0,0,1,.054,5.5.675.675,0,0,1,0,5.226a.709.709,0,0,1,.2-.495L4.683.216A.693.693,0,0,1,5.673.2Z",
    transform: "translate(10922.815 -10216.372) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-round-back-2",
    "data-name": "Icon ionic-ios-arrow-round-back",
    d: "M5.673,10.244a.711.711,0,0,0,.005-1l-3.3-3.313H14.958a.707.707,0,0,0,0-1.414H2.377L5.684,1.2a.716.716,0,0,0-.005-1,.7.7,0,0,0-1,.005L.2,4.723h0a.794.794,0,0,0-.147.223A.675.675,0,0,0,0,5.218a.709.709,0,0,0,.2.495l4.482,4.515A.693.693,0,0,0,5.673,10.244Z",
    transform: "translate(10922.815 -10200.712) rotate(-90)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuffle);
export default __webpack_public_path__ + "static/media/shuffle.e4f3f150943960bdefd4b909e0b134d7.svg";
export { ForwardRef as ReactComponent };